export const RECAP_HEIGHT = 640;
export const RECAP_WIDTH = 360;
export const STORY_INTERVAL = 5000;

export const MIN_WEEKS_STREAK = 4;
export const MAX_RANK = 60;

export const storyGradients = {
    purpleToPrimary: 'linear-gradient(222deg, #153BFF -39.16%, #90C 115.34%)',
    pinkToOrange: 'linear-gradient(104deg, #F3C -32.24%, #FF971D 162.98%)',
    pinkToPurple: 'linear-gradient(250deg, #90C -21.94%, #F3C 136.54%)',
    lightOrange: 'linear-gradient(251deg, #FFEAD2 0%, #FFE7F9 99.86%)',
    lightPurple: 'linear-gradient(43deg, #E3E7FF 4.01%, #FFE7F9 94.18%)',
    lightPink: 'linear-gradient(71deg, #FFE7F9 0%, #F3E0F9 99.86%)',
} as const;

export type StoryGradients = (typeof storyGradients)[keyof typeof storyGradients];

export const textGradientPink = 'linear-gradient(28deg, #E55771 -4.94%, #CF3A8B 100%)';
export const textGradientPrimary = 'linear-gradient(61deg, #7E0EEC -7.71%, #2F3DE9 107.59%)';
export const textGradientPurple = 'linear-gradient(37deg, #CC38A4 -5.13%, #8B2AEA 111.49%)';

export const paperGradient =
    'linear-gradient(42deg, #E3E7FF 4.85%, #F3E0F9 69.92%, #FFE7F9 113.78%)';

export const componentsZIndexes = {
    reactInstaStories: 999,
    lastScreenBackNavigationClickArea: 1000,
    interactiveElements: 1001,
};

export const recapTrackedEvents = {
    click: {
        LaunchWrapUp: 'LaunchWrapUp',
        ShareYearWrapUp: 'ShareYearWrapUp',
    },
    pageView: {
        WrapUpFirstScreen: 'WrapUpFirstScreen',
        WrapUpClasses: 'WrapUpClasses',
        WrapUpWeekStreak: 'WrapUpWeekStreak',
        WrapUpExercises: 'WrapUpExercises',
        WrapUpCertificates: 'WrapUpCertificates',
        WrapUpTopLearner: 'WrapUpTopLearner',
        WrapUpTeachers: ' WrapUpTeachers',
        WrapUpTopSkills: 'WrapUpTopSkills',
        WrapUpSummary: ' WrapUpSummary',
    },
} as const;
